module.exports = __webpack_public_path__ + "static/media/circle-check.a6e22dab.svg";